export const domainMessages = {
    en: {
        resources: {
            'processing-requests': {
                name: 'Processing Request |||| Processing Requests',
            },
        }
    }
};